import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=5d2c0beb&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=5d2c0beb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2c0beb",
  null
  
)

export default component.exports